/* Theme-side consent gate. This does not enforce checkout rules server-side. */
if (!customElements.get('charamoa-cart-consent')) {
  customElements.define('charamoa-cart-consent', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('change', () => this.sync(), { signal });
      document.addEventListener('submit', (event) => {
        if (event.target.id !== 'cart') return;
        if (event.submitter && event.submitter.name !== 'checkout') return;
        if (!this.sync()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const missing = this.querySelector('input[type="checkbox"]:not(:checked)');
          if (this.dataset.policiesReady === 'true' && missing) {
            this.querySelector('#CartConsent-error').textContent = '利用規約と個人情報の取り扱いについて、両方への同意が必要です。';
            missing.focus();
            missing.reportValidity();
          } else {
            this.querySelector('#CartConsent-error').focus();
          }
        }
      }, { capture: true, signal });
      window.addEventListener('pageshow', () => this.sync(), { signal });
      this.footer = this.closest('#main-cart-footer');
      this.observer = new MutationObserver(() => this.sync());
      if (this.footer) this.observer.observe(this.footer, { attributes: true, attributeFilter: ['class'] });
      this.sync();
    }

    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
    }

    sync() {
      const policiesReady = this.dataset.policiesReady === 'true';
      const inputs = [...this.querySelectorAll('input[type="checkbox"]')];
      const empty = !this.footer || this.footer.classList.contains('is-empty');
      const ready = policiesReady && !empty && inputs.length === 2 && inputs.every((input) => input.checked);
      this.querySelector('[name="checkout"]').disabled = !ready;
      const error = this.querySelector('#CartConsent-error');
      error.tabIndex = -1;
      error.textContent = policiesReady ? '' : 'ポリシーが未設定のため、現在購入手続きに進めません。お問い合わせください。';
      return ready;
    }
  });
}
